import { styled } from "@mui/material";

export const Label = styled("span")`
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral.medium[800]};
`;

export const Wrapper = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
